const AccessLevels = Object.freeze({
  SuperAdmin: 'SuperAdmin',
  Admin: 'Admin',
  Server: 'Server',
});

export default AccessLevels;
